import React, { useRef, useEffect, useContext, useState } from 'react';

//******************************************Componentes PrimeReact*********************************************************** */
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

//****************************************Servicios Creados********************************************************* */
import { getDateProduction } from '../../Services/FechasService';
import { getDatesHorarioNormal } from '../../Services/Moment/Luxon'
import { toastShow } from '../../Services/ToastService'
import { getCalendarioFinanzasMensual } from '../../API/Global/CalendarioFinanzas/CalendarioFinanzasRequest';
import { ConfigContext } from '../../Context/ConfigContext/ConfigContext';
import { Dropdown } from 'primereact/dropdown';

const CalendarioMensual = ({ getInfo, data, setData, selected, setSelected, dates, setDates, loading, setLoading, type = 'Normal' }) => {

    const toast = useRef(null);
    const [meses, setMeses] = useState([]);
    const { config } = useContext(ConfigContext);
    const [mes, setMes] = useState(null)

    const obtenerInformacionFechas = async (dates) => {

        setLoading(true)
        setData([])

        if (!dates[0] !== null) {
            if (!dates[1]) {
                toastShow(toast, 'warn', 'Error', 'Seleccione dos fechas para buscar');
            }
            else {

                const fechaFormato = getDatesHorarioNormal(dates)
                const result = await getInfo(fechaFormato)

                if (type === 'Acumulado') {
                    OrdenarData(result)
                } else {

                    setData(result)
                }

            }

        } else {
            toastShow(toast, 'error', 'Error', 'Debe de selecionar una fecha.');
        }

        setLoading(false)
    }

    const OrdenarData = (result) => {
        // setLoading(true)
        let sumaTotal = 0;

        result.forEach((objeto) => {
            objeto.Acumulado = sumaTotal + objeto.Balance;
            sumaTotal += objeto.Balance;
        });

        setData(result.sort())
        // setLoading(false)

    }

    const obtenerInfoCalendario = async () => {
        const tempoCalendario = await getCalendarioFinanzasMensual()
        let calendarioMeses = []

        calendarioMeses = tempoCalendario.map((e) => {
            let mesName = config.language === 'es' ? e.MesEsLargo : e.MesEnLargo;
            return {
                IdCDetalle: e.IdMes,
                IdMes: e.IdMes,
                Mes: mesName,
                Semanas: e.NoSemanas,
                FechaInicio: (e.InicioMes),
                FechaFinal: (e.FinMes),
                Anio: e.Anio,
                MesRango: mesName + "-" + e.Anio,
                MesNumero: e.NoMes

            }
        })
        setMeses(calendarioMeses)
        let fechaActual = new Date();
        let year = new Date().getFullYear();
        let mes = new Date().getMonth() + 1
        let a = calendarioMeses.find((e) => mes === e.MesNumero && year === e.Anio)
        if (a) {
            setMes(a?.IdCDetalle)
        }
        AsignarFechas(fechaActual)


    }

    const AsignarFechas = (fecha) => {
        let primerDia = new Date(fecha.getFullYear(), fecha.getMonth(), 1);
        let ultimoDia = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0);
        let fechaMes = [primerDia, ultimoDia]
        setDates(fechaMes)
        obtenerInformacionFechas(fechaMes)
    }

    const filtrarMeses = (IdMes) => {
        let tempoMes = meses.find((e) => e.IdMes === IdMes)
        let tempoFecha = new Date(tempoMes?.MesNumero + '-' + '01-' + tempoMes?.Anio)
        if (tempoFecha) {
            AsignarFechas(tempoFecha)
            setMes(IdMes)
        }
    }



    // const obtenerFechas = () => {

    //     let fechaActual = new Date();
    //     let primerDia = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);
    //     let ultimoDia = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);
    //     let fechaMes = [primerDia, ultimoDia]
    //     setDates(fechaMes)
    //     obtenerInformacionFechas(fechaMes)

    // }

    useEffect(() => {
        obtenerInfoCalendario()
    }, [])

    return (
        <div>
            <Dropdown id="IdCDetalle" name="IdCDetalle" style={{ height: 35, width: 220 }} filter filterBy='MesRango' className='mx-2'
                onChange={(e) => filtrarMeses(e.value)} value={mes} optionValue="IdCDetalle" optionLabel="MesRango" options={meses} />
            <Calendar id="range" value={dates} onChange={(e) => setDates(e.value)} showButtonBar showIcon selectionMode="range" style={{ height: 35, width: 245 }} />
            <Button icon='pi pi-search' onClick={() => obtenerInformacionFechas(dates)} className='mx-2' style={{ height: 35 }} loading={loading} />
        </div>
    )
}

export default CalendarioMensual
